import React from 'react';
import { Modal, Form, Button, ListGroup } from 'react-bootstrap';
import { renderMarkdown } from './renderMarkdown';

function ChallengeDetailModal({ challenge, onHide, flagInputs, setFlagInputs, submissionStatus, onSubmitFlag }) {
    if (!challenge) return null;

    return (
        <Modal
            show={!!challenge}
            onHide={onHide}
            size="lg"
            className="training-modal"
        >
            <Modal.Header closeButton className="training-modal-header">
                <Modal.Title className="training-modal-title">
                    {challenge.title}
                    <div className="training-modal-category">{challenge.category}</div>
                    <div className={`training-difficulty-tag training-difficulty-${challenge.difficulty}`}>
                        {challenge.difficulty}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="training-modal-body">
                <div className="training-modal-content">
                    <section className="training-desc-section">
                        <h5>Description</h5>
                        <div className="prose max-w-none">
                            {renderMarkdown(challenge.description)}
                        </div>
                        {challenge.file_link && (
                            <Button
                                variant="outline-primary"
                                href={challenge.file_link}
                                target="_blank"
                                className="training-file-button mt-4"
                            >
                                Download File
                            </Button>
                        )}
                    </section>

                    <section className="training-flag-section">
                        <h5>Submit Flags</h5>
                        {challenge.flags?.length > 1 ? (
                            challenge.flags.map((flag, index) => (
                                <FlagInput
                                    key={index}
                                    flag={flag}
                                    challengeId={challenge.id}
                                    flagInputs={flagInputs}
                                    setFlagInputs={setFlagInputs}
                                    submissionStatus={submissionStatus}
                                    onSubmitFlag={onSubmitFlag}
                                />
                            ))
                        ) : (
                            <FlagInput
                                flag={challenge.flags?.[0] || { name: 'Flag' }}
                                challengeId={challenge.id}
                                flagInputs={flagInputs}
                                setFlagInputs={setFlagInputs}
                                submissionStatus={submissionStatus}
                                onSubmitFlag={onSubmitFlag}
                                isSingle
                            />
                        )}
                    </section>

                    <section className="training-completion-section">
                        <h5>Completed By</h5>
                        {challenge.completed_by?.length > 0 ? (
                            <ListGroup className="training-completion-list">
                                {challenge.completed_by.map((completion, index) => (
                                    <ListGroup.Item key={index} className="training-completion-item">
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <span>
                                                {completion.username}
                                                {completion.is_multi_flag && ` - ${completion.flag_name}`}
                                            </span>
                                            <small className="text-muted">
                                                {new Date(completion.completed_at).toLocaleString('en-GB', {
                                                    day: '2-digit', month: '2-digit', year: 'numeric',
                                                    hour: '2-digit', minute: '2-digit', second: '2-digit'
                                                })}
                                            </small>
                                        </div>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        ) : (
                            <p className="training-no-completions">
                                {challenge.flags?.length > 1
                                    ? "No one has completed any flags for this challenge yet!"
                                    : "No one has completed this challenge yet!"}
                            </p>
                        )}
                    </section>
                </div>
            </Modal.Body>
        </Modal>
    );
}

function FlagInput({ flag, challengeId, flagInputs, setFlagInputs, submissionStatus, onSubmitFlag, isSingle }) {
    const flagName = flag.name || 'Flag';
    return (
        <div className="training-flag-group mb-4">
            <h6>{flagName}</h6>
            <Form className="training-flag-form">
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder={`Enter ${flagName}`}
                        value={flagInputs[flagName] || ''}
                        onChange={(e) => setFlagInputs(prev => ({ ...prev, [flagName]: e.target.value }))}
                        className="training-flag-input"
                    />
                </Form.Group>
                <Button
                    variant="primary"
                    className="training-submit-button"
                    onClick={() => onSubmitFlag(challengeId, flagName, flagInputs[flagName])}
                >
                    Submit {isSingle ? 'Flag' : flagName}
                </Button>
                {submissionStatus[flagName] && (
                    <div className={`training-status ${submissionStatus[flagName].includes('successfully') ? 'training-success' : 'training-error'}`}>
                        {submissionStatus[flagName]}
                    </div>
                )}
            </Form>
        </div>
    );
}

export default ChallengeDetailModal;
